/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';

/* Generic icon component for all icons in our icon font */

const StatusPill = ({ status }) => {
  let pillClass = 'status-pill--';
  switch (status) {
    case ('active'):
    case ('published'):
      pillClass += 'published';
      break;
    case ('applying'):
    case ('applied'):
    case ('onboarding'):
    case ('accepted'):
    case ('review'):
    case ('requested'):
    case ('draft'):
      pillClass += 'draft';
      break;
    case ('canceled'):
    case ('inactive'):
    case ('rejected'):
    case ('did_not_join'):
    case ('archived'):
    case ('expired'):
      pillClass += 'archived';
      break;
    case ('true'):
    case ('yes'):
      pillClass += 'yes';
      break;
    case ('false'):
    case ('no'):
      pillClass += 'no';
      break;
    default:
  }
  return (<div className={`status-pill ${pillClass}`}>{status.split('_').join(' ')}</div>);
};

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusPill;
